
import React, { useEffect, useRef } from "react";
import { Chart } from "chart.js";
import data from './data.json';

export default function Mainblock() {
  const tbodyRef = useRef(null);
  const popupRef = useRef(null);
  const closeBtnRef = useRef(null);
  const statsBtnRef = useRef(null);
  const hideStatsBtnRef = useRef(null);

  useEffect(() => {
    const tbody = tbodyRef.current;
    if (!tbody) return;

    // Clear existing children
    while (tbody.firstChild) {
      tbody.removeChild(tbody.firstChild);
    }

    data.forEach((item) => {
      const tr = document.createElement('tr');

      const td1 = document.createElement('td');
      td1.textContent = item.id;

      const td2 = document.createElement('td');
      td2.textContent = item.name;

      const td3 = document.createElement('td');
      td3.textContent = item.ticket_number;

      const td9 = document.createElement('td');
      td9.textContent = item.ticket_topic;

      const td4 = document.createElement('td');
      td4.textContent = item.rating_grade;

      const td5 = document.createElement('td');
      td5.textContent = item.exam_grade;

      let final = 0.6 * item.exam_grade + 0.4 * item.rating_grade;
      const td6 = document.createElement('td');
      td6.textContent = final.toFixed(2);

      const td7 = document.createElement('td');
      td7.textContent = final > 4 ? "Passed" : "Failed";

      const td8 = document.createElement('td');
      const detailsBtn = document.createElement('button');
      detailsBtn.textContent = 'Details';
      detailsBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent row click handler
        const popup = popupRef.current;
        const popupTitle = document.querySelector('#popup-title');
        const popupText = document.querySelector('#popup-text');

        if (popupTitle) popupTitle.textContent = item.name;
        if (popupText) {
          popupText.innerHTML = `
            <span style="font-size: large; color: red;">ID: </span><em>${item.id}</em><br>
            <span style="font-size: large; color: red;">Name: </span><em>${item.name}</em><br>
            <span style="font-size: large; color: red;">Ticket Number: </span><em>${item.ticket_number}</em><br>
            <span style="font-size: large; color: red;">Ticket Topic: </span><em>${item.ticket_topic}</em><br>
            <span style="font-size: large; color: red;">Exam Grade: </span><em>${item.exam_grade}</em><br>
            <span style="font-size: large; color: red;">Rating Grade: </span><em>${item.rating_grade}</em><br>
            <span style="font-size: large; color: red;">Comments: </span><em>${item.comments}</em>
          `;
        }
        if (popup) popup.style.display = 'flex';
      });

      td8.appendChild(detailsBtn);

      tr.appendChild(td1);
      tr.appendChild(td2);
      tr.appendChild(td3);
      tr.appendChild(td9);
      tr.appendChild(td4);
      tr.appendChild(td5);
      tr.appendChild(td6);
      tr.appendChild(td7);
      tr.appendChild(td8);

      tr.onclick = function () {
        this.classList.toggle("selected");
        const nameCell = this.children[1];
        if (this.classList.contains("selected")) {
          nameCell.textContent = nameCell.textContent.toUpperCase();
        } else {
          const name = nameCell.textContent.toLowerCase();
          nameCell.textContent = name.charAt(0).toUpperCase() + name.slice(1);
        }
      };

      tbody.appendChild(tr);
    });

    const closeBtn = closeBtnRef.current;
    if (closeBtn) {
      closeBtn.onclick = () => {
        if (popupRef.current) popupRef.current.style.display = 'none';
      };
    }
  }, []);


  const style = {
    color: 'black',
    fontSize: 'x-large',
    fontWeight: 'bolder',
  }
  const style2 = {
    marginTop: '120px',
  }
  const style3 = {
    verticalAlign: 'top',
    display: 'inline-block',

  }
  // createTable();
  return (
    <>
      <div id="overflow">
        <table id="myTable" >
          <thead>
            <tr>
              <th>No</th>
              <th id="name-header">Name &#8595;</th>
              <th>Ticket's Number</th>
              <th>Ticket's Topic</th>
              <th>Rating Grade</th>
              <th>Exam Grade</th>
              <th id="final-grade">Final Grade &#8595;</th>
              <th>Status</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody ref={tbodyRef}>
          </tbody>
        </table>
        <button id="stats" ref={statsBtnRef}>Statistics</button>
        <button id="hidestats" ref={hideStatsBtnRef}>Hide</button>

        <div id="statistics" className="hidden">
          <div class="students-info">
            Total students: <span id="total-students">0</span>
          </div>

          <canvas id="myChart" width="600" height="400" style={style3}></canvas>
          <canvas id="pie" width="500" height="400" style={style3}></canvas>

          <div id="statscontent">
            <canvas id="line" width="800" height="400" style={style3}></canvas>

            <ul></ul>
          </div>
        </div>
        <div id="popup" class="popup" ref={popupRef}>
          <div class="popup-content">
            <span class="close-btn" style={style} ref={closeBtnRef}>&times;</span>
            <h1 id="popup-title" style={style2}> </h1>
            <p id="popup-text"></p>
          </div>
        </div>
      </div>
    </>
  )
}    